import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './stores/authStore';
import Layout from './components/Layout';
import Landing from './pages/Landing';
import Pricing from './pages/Pricing';
import Skills from './pages/Skills';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import Dashboard from './pages/Dashboard';
import VoiceDesign from './pages/VoiceDesign';
import VoiceClone from './pages/VoiceClone';
import Transcribe from './pages/Transcribe';
import UserManagement from './pages/UserManagement';
import Stats from './pages/Stats';
import Profile from './pages/Profile';
import EmailConfig from './pages/EmailConfig';
import InvitationCodes from './pages/InvitationCodes';
import ApiDocs from './pages/ApiDocs';

// 受保护路由组件
const ProtectedRoute = ({ children, requireAdmin = false }: { children: React.ReactNode; requireAdmin?: boolean }) => {
  const { isAuthenticated, isAdmin } = useAuthStore();
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  if (requireAdmin && !isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }
  
  return <>{children}</>;
};

function App() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/skills" element={<Skills />} />
      <Route path="/api-docs" element={<ApiDocs />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="voice-design" element={<VoiceDesign />} />
        <Route path="voice-clone" element={<VoiceClone />} />
        <Route path="transcribe" element={<Transcribe />} />
        <Route path="profile" element={<Profile />} />
        <Route
          path="users"
          element={
            <ProtectedRoute requireAdmin>
              <UserManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="stats"
          element={
            <ProtectedRoute requireAdmin>
              <Stats />
            </ProtectedRoute>
          }
        />
        <Route
          path="email-config"
          element={
            <ProtectedRoute requireAdmin>
              <EmailConfig />
            </ProtectedRoute>
          }
        />
        <Route
          path="invitation-codes"
          element={
            <ProtectedRoute requireAdmin>
              <InvitationCodes />
            </ProtectedRoute>
          }
        />
      </Route>
    </Routes>
  );
}

export default App;
